import { ControlData } from "../model/manifest/ControlData";

export const getPrefix = (control: ControlData): string | undefined => {
    return control.Prefix == null || control.Prefix === "" ? undefined : control.Prefix;
}

export const getSuffix = (control: ControlData): string | undefined => {
    return control.Suffix == null || control.Suffix === "" ? undefined : control.Suffix;
}